import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyLifeActsDownloadButtonComponent } from './myLifeActsDownloadButton.component';
import { ButtonModule } from '@app/components/button/button.module';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { PlPopoverModule } from '@app/components/pl-popover/pl-popover.module';

@NgModule({
  declarations: [MyLifeActsDownloadButtonComponent],
  exports: [MyLifeActsDownloadButtonComponent],
  imports: [CommonModule, ButtonModule, PlIconModule, TranslateModule, PlPopoverModule],
})
export class MyLifeActsDownloadButtonModule {}
